<script lang="ts" setup>
import { Head, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { PropertiesInterface } from '~/types';

const meta = computed(() => usePage<PropertiesInterface>().props.meta);
const title = computed(() => meta.value?.title);
const description = computed(() => meta.value?.description);
const keywords = computed(() => meta.value?.keywords);
const fields = computed(() => meta.value?.fields || []);
const properties = computed(() => fields?.value.filter((item) => item.type === 'property'));
const names = computed(() => fields.value?.filter((item) => item.type === 'name'));
</script>

<template>
  <Head>
    <title>{{ title }}</title>
    <meta v-if="description" :content="description" name="description" />
    <meta v-if="keywords" :content="keywords" name="keywords" />

    <meta
      v-for="(metaValue, index) in properties"
      :key="index"
      :content="metaValue.content"
      :property="metaValue.name"
    />

    <meta v-for="(metaValue, index) in names" :key="index" :content="metaValue.content" :name="metaValue.name" />
  </Head>
</template>
